export const GET_ALL_JACKPOTS = "GET_ALL_JACKPOTS"
export const GET_ALL_JACKPOTS_RESPONSE_SUCCESS =
  "GET_ALL_JACKPOTS_RESPONSE_SUCCESS"
export const CREATE_JACKPOT = "CREATE_JACKPOT"
export const UPDATE_JACKPOT = "UPDATE_JACKPOT"
export const DELETE_JACKPOT = "DELETE_JACKPOT"
